(function(){

  window.__zestPD = window.__zestPD || {};

  /* ========================================================
     🔧 DEV MODE SWITCH
     ======================================================== */
  const DEV_MODE = false;   // 🔴 CHANGE TO false WHEN GOING LIVE

  /* ========================================================
     VERSION CONTROL
     ======================================================== */
var ZEST_PD_VERSION = '2026-02-20-release-v1';


  if (
    window.__zestPD.inited &&
    window.__zestPD.version === ZEST_PD_VERSION &&
    typeof window.__zestPD.sync === 'function'
  ){
    window.__zestPD.sync(true);
    return;
  }

  window.__zestPD.inited = true;
  window.__zestPD.version = ZEST_PD_VERSION;

  /* ========================================================
     SAFE LOGGER (DEV ONLY)
     ======================================================== */
  function devLog(){
    if (!DEV_MODE) return;
    try { console.log('[ZEST PD]', ...arguments); } catch(e){}
  }

  function decodeEntities(s){
    if (!s) return '';
    const el = document.createElement('textarea');
    el.innerHTML = s;
    return el.value;
  }

  function getMap(){
    try {
      return JSON.parse(document.getElementById('VariantMetafields')?.textContent || '{}');
    } catch(e){
      return {};
    }
  }

  function getProductMeta(){
    try {
      return JSON.parse(document.getElementById('ProductMetafields')?.textContent || '{}');
    } catch(e){
      return {};
    }
  }

  // Prefer the variant selector that is in the SAME product section as #variant-specs
  function getVariantIdFromForm(){
    const root = document.getElementById('variant-specs');
    const scope = root ? (root.closest('main, section, .shopify-section, .product') || document) : document;

    // Dawn/OS 2.0 product forms
    const sel = scope.querySelector('form[action*="/cart/add"] [name="id"]')
             || scope.querySelector('[name="id"][form]');

    return sel && sel.value;
  }

  function getVariantIdFromURL(){
    try { return new URL(window.location.href).searchParams.get('variant'); }
    catch(e){ return null; }
  }

  function setRow(root, key, label, value){
    const row = root.querySelector('.spec-item[data-field="'+key+'"]');
    if (!row) return;
    const labelEl = row.querySelector('.spec-label');
    const valueEl = row.querySelector('.spec-value');

    const v = (value || '').toString().trim();
    const hasValue = v.length > 0;

    row.style.display = hasValue ? '' : 'none';
    if (!hasValue) return;

    if (labelEl && label) labelEl.textContent = label;
    if (valueEl) valueEl.textContent = v;
  }

  /* ============================================================
     ✅ Shared luminance helper (used by beadSvg + segmented summary)
     ============================================================ */
  function _hexToRgb(hex){
    const h = (hex || '').toString().replace('#','').trim();
    if (h.length !== 6) return null;
    const r = parseInt(h.slice(0,2), 16);
    const g = parseInt(h.slice(2,4), 16);
    const b = parseInt(h.slice(4,6), 16);
    if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) return null;
    return { r, g, b };
  }
  function _srgbToLin(c){
    const v = c / 255;
    return (v <= 0.04045) ? (v / 12.92) : Math.pow((v + 0.055) / 1.055, 2.4);
  }
  function _relLuma(hex){
    const rgb = _hexToRgb(hex);
    if (!rgb) return 1; // unknown -> treat as bright
    const R = _srgbToLin(rgb.r);
    const G = _srgbToLin(rgb.g);
    const B = _srgbToLin(rgb.b);
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
  }

  /* ============================================================
     🔒 LOCKED: PLATING PARSER (CANONICAL)
     ============================================================ */
  function parsePlatings(platingText){
    return (platingText || '')
      .toString()
      .split(',')
      .map(s => s.trim())
      .filter(Boolean)
      .slice(0, 2);
  }

/* ============================================================
   3-PLATING EXTENSION HELPERS (NON-LOCKED)
   ============================================================ */
function parsePlatingsUpTo3(platingText){
  return (platingText || '')
    .toString()
    .split(',')
    .map(s => s.trim())
    .filter(Boolean)
    .slice(0, 3);
}

/* ============================================================
PATCH ID: ZEST-PD-PATCH-20260218-09
TYPE: Bug fix
PURPOSE:
- Make 3-plating summary icon split into TRUE equal thirds (120° wedges)
- Outer rim stroke is also split into equal thirds
ROLLBACK:
- Restore previous platingSvgThirds()
============================================================ */
function platingSvgThirds(c1, c2, c3){
  const a = c1 || {};
  const b = c2 || {};
  const c = c3 || {};

  const fills = [
    a.fill || '#dcdcdc',
    b.fill || '#d8d8d8',
    c.fill || '#e6a2a2'
  ];

  const strokes = [
    a.stroke || '#b8b8b8',
    b.stroke || (a.stroke || '#b8b8b8'),
    c.stroke || (a.stroke || '#b8b8b8')
  ];

  const inner  = '#000';
  const center = '#ffffff';

  const CX = 12, CY = 12;
  const R_FILL = 9;     // match your existing outer radius
  const R_RIM  = 9;     // rim arc radius
  const R_INNER = 4.8;  // match your existing inner ring

  // Start at top (-90°) so it looks balanced in UI
  const startBase = -Math.PI / 2;
  const step = (Math.PI * 2) / 3; // 120°

  function polar(r, ang){
    return { x: CX + r * Math.cos(ang), y: CY + r * Math.sin(ang) };
  }

  // Wedge from center to outer circle (hole covers the center anyway)
  function wedgePath(a0, a1){
    const p0 = polar(R_FILL, a0);
    const p1 = polar(R_FILL, a1);
    return `M ${CX} ${CY} L ${p0.x.toFixed(3)} ${p0.y.toFixed(3)}
            A ${R_FILL} ${R_FILL} 0 0 1 ${p1.x.toFixed(3)} ${p1.y.toFixed(3)} Z`;
  }

  // Outer rim arc (no fill)
  function rimArcPath(a0, a1){
    const p0 = polar(R_RIM, a0);
    const p1 = polar(R_RIM, a1);
    return `M ${p0.x.toFixed(3)} ${p0.y.toFixed(3)}
            A ${R_RIM} ${R_RIM} 0 0 1 ${p1.x.toFixed(3)} ${p1.y.toFixed(3)}`;
  }

  // Tiny overlap to hide hairline seams between segments (very small)
  const EPS = 0.002;

  const wedges = [0,1,2].map(i => {
    const a0 = startBase + step * i - EPS;
    const a1 = startBase + step * (i + 1) + EPS;
    return `<path d="${wedgePath(a0, a1)}" fill="${fills[i]}" stroke="none"></path>`;
  }).join('');

  const rim = [0,1,2].map(i => {
    const a0 = startBase + step * i;
    const a1 = startBase + step * (i + 1);
    return `<path d="${rimArcPath(a0, a1)}"
                 fill="none"
                 stroke="${strokes[i]}"
                 stroke-width="2.5"
                 stroke-linecap="butt"></path>`;
  }).join('');

  return `
    <svg class="zest-plating" viewBox="0 0 24 24" aria-hidden="true">
      ${wedges}
      ${rim}
      <circle cx="${CX}" cy="${CY}" r="${R_INNER}" fill="${center}" stroke="${inner}" stroke-width="1.6"></circle>
    </svg>
  `;
}


/* ============================================================
   🔒 LOCKED: GEM COLOUR MAPPER
   ============================================================ */
function gemFill(name){
  const n = (name || '').toLowerCase();

  if (n.includes('ruby')) return '#8b1a2b';
  if (n.includes('garnet')) return '#7d1531';
  if (n.includes('tiger eye') || n.includes('tiger')) return '#a8742a';

  if (n.includes('london blue')) return '#0b3f73';
  if (n.includes('swiss blue')) return '#2d8fd6';

  // ---- Yellow family overrides (must beat generic "sapphire") ----
  // Accept: "yellow sapphire", "yellow-sapphire"
  if (/\byellow[-\s]+sapphire\b/.test(n)) return '#d4a017';  // Z’EST golden yellow

  // Accept: "yellow citrine", "yellow-citrine"
  if (/\byellow[-\s]+citrine\b/.test(n)) return '#D88A17';   // Z’EST deep amber

  // ---- Generic families ----
  if (n.includes('sapphire')) return '#1f4fb3';
  if (n.includes('aquamarine')) return '#b9e3f2';

  if (n.includes('amethyst')) return '#6a2fb8';

  if (n.includes('pink tourmaline')) return '#ff4aa3';
  if (n.includes('rhodolite')) return '#c64a8c';
  if (n.includes('pink')) return '#ff4aa3';

  if (n.includes('green diopside')) return '#1f8a5b';
  if (n.includes('peridot')) return '#6aa600';
  if (n.includes('green')) return '#1f8a5b';

  if (
    n.includes('white zirconium') ||
    n.includes('zircon') ||
    n.includes('white topaz')
  ) return '#ffffff';

  if (n.includes('black onyx') || n.includes('onyx')) return '#1a1a1a';

  return '#7a1a2b';
}

  /* ============================================================
     🔒 LOCKED: PLATING COLOUR MAPPER
     ============================================================ */
  function platingColors(name){
    const n = (name || '').toLowerCase();

    if (n.includes('white gold')){
      return { fill:'#dcdcdc', stroke:'#b8b8b8', inner:'#000', center:'#ffffff' };
    }
    if (n.includes('rose gold')){
      return { fill:'#e6a2a2', stroke:'#b8756b', inner:'#000', center:'#ffffff' };
    }
    if (n.includes('18k') || n.includes('gold plated') || n === 'gold'){
      return { fill:'#d1a93c', stroke:'#8a6d1d', inner:'#000', center:'#ffffff' };
    }
    if (n.includes('rhodium') || n.includes('silver')){
      return { fill:'#d8d8d8', stroke:'#a8a8a8', inner:'#000', center:'#ffffff' };
    }
    return { fill:'#dcdcdc', stroke:'#b8b8b8', inner:'#000', center:'#ffffff' };
  }

  /* ============================================================
     🔒 LOCKED: PLATING SVG BUILDERS (CANONICAL)
     ============================================================ */
  function platingSvgSingle(c){
    const fill   = c?.fill   || '#dcdcdc';
    const stroke = c?.stroke || '#b8b8b8';
    const inner  = c?.inner  || '#000';
    const center = c?.center || '#ffffff';

    return `
      <svg class="zest-plating" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="9" fill="${fill}" stroke="${stroke}" stroke-width="2.5"></circle>
        <circle cx="12" cy="12" r="4.8" fill="${center}" stroke="${inner}" stroke-width="1.6"></circle>
      </svg>
    `;
  }
/* ============================================================
PATCH ID: ZEST-PD-PATCH-20260218-07
TYPE: Bug fix
PURPOSE:
- Split the OUTER RIM (stroke) for 2-plating summary icons
- Uses gradients (no clipPath seams, and rim can split)
ROLLBACK:
- Restore previous platingSvgSplit()
============================================================ */
function platingSvgSplit(c1, c2){
  const a = c1 || {};
  const b = c2 || {};

  const aFill   = a.fill   || '#dcdcdc';
  const bFill   = b.fill   || '#d8d8d8';
  const aStroke = a.stroke || '#b8b8b8';
  const bStroke = b.stroke || aStroke;

  const inner  = '#000';
  const center = '#ffffff';

  // ✅ unique ids to avoid collisions
  platingSvgSplit.__uid = (platingSvgSplit.__uid || 0) + 1;
  const uid = platingSvgSplit.__uid;
  const fillId   = 'zestPlatingFillSplit_' + uid;
  const strokeId = 'zestPlatingStrokeSplit_' + uid;

  return `
    <svg class="zest-plating" viewBox="0 0 24 24" aria-hidden="true">
      <defs>
        <!-- Hard split at 50% for fill -->
        <linearGradient id="${fillId}" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%"   stop-color="${aFill}"></stop>
          <stop offset="50%"  stop-color="${aFill}"></stop>
          <stop offset="50%"  stop-color="${bFill}"></stop>
          <stop offset="100%" stop-color="${bFill}"></stop>
        </linearGradient>

        <!-- Hard split at 50% for OUTER RIM stroke -->
        <linearGradient id="${strokeId}" x1="0" y1="0" x2="1" y2="0">
          <stop offset="0%"   stop-color="${aStroke}"></stop>
          <stop offset="50%"  stop-color="${aStroke}"></stop>
          <stop offset="50%"  stop-color="${bStroke}"></stop>
          <stop offset="100%" stop-color="${bStroke}"></stop>
        </linearGradient>
      </defs>

      <!-- main disc -->
      <circle cx="12" cy="12" r="9"
              fill="url(#${fillId})"
              stroke="url(#${strokeId})"
              stroke-width="2.5"></circle>

      <!-- inner ring (kept canonical) -->
      <circle cx="12" cy="12" r="4.8"
              fill="${center}"
              stroke="${inner}"
              stroke-width="1.6"></circle>
    </svg>
  `;
}

/* ============================================================
PATCH ID: ZEST-PD-PATCH-20260218-PLATING-PACK-ALIGN-v2
TYPE: Bug fix
PURPOSE:
- Keep multi-icon plating sets from splitting across lines
- Fix baseline alignment for single (non-wrapped) icon sets by avoiding line-height:0 on the pack
SCOPE:
- Full replacement of setPlatingRowIcons()
ROLLBACK:
- Restore previous setPlatingRowIcons()
============================================================ */
function setPlatingRowIcons(root, platingText){
  const row = root.querySelector('.spec-item[data-field="variant_plating"]');
  if (!row) return;

  const valueEl = row.querySelector('.spec-value');

  // Find existing icon spans
  let icon1 = row.querySelector('.spec-icon.zest-i--plating') || row.querySelector('.spec-icon');
  let icon2 = row.querySelector('.spec-icon.zest-i--plating2');
  let icon3 = row.querySelector('.spec-icon.zest-i--plating3');

  // Platings (up to 3)
  const plats = parsePlatingsUpTo3(platingText);
  const has = plats.length > 0;

  function hide(el){
    if (!el) return;
    el.style.display = 'none';
    el.innerHTML = '';
  }

  // Build / reuse a single “pack” wrapper so icons can’t wrap between themselves
  let pack = row.querySelector('.zest-pack--plating');
  if (!pack){
    pack = document.createElement('span');
    pack.className = 'zest-pack--plating';
    pack.setAttribute('aria-hidden', 'true');

    // Baseline-friendly inline-flex wrapper
    pack.style.display = 'inline-flex';
    pack.style.alignItems = 'center';
    pack.style.gap = '6px';
    pack.style.whiteSpace = 'nowrap';
    pack.style.verticalAlign = 'middle';
    pack.style.lineHeight = '1'; // ✅ was 0 -> caused baseline misalignment

    // Insert after the value
    if (valueEl && valueEl.parentNode){
      valueEl.parentNode.insertBefore(pack, valueEl.nextSibling);
    } else {
      row.appendChild(pack);
    }
  } else {
    // Ensure baseline-friendly styles persist
    pack.style.display = 'inline-flex';
    pack.style.alignItems = 'center';
    pack.style.whiteSpace = 'nowrap';
    pack.style.verticalAlign = 'middle';
    pack.style.lineHeight = '1';
  }

  // Helper: create icon if missing, ensure inside pack, and baseline-safe
  function ensureIcon(ref, className){
    let el = ref;
    if (!el){
      el = document.createElement('span');
      el.className = 'spec-icon ' + className;
      el.setAttribute('aria-hidden', 'true');
    } else {
      if (!el.classList.contains('spec-icon')) el.classList.add('spec-icon');
      if (className) el.classList.add(className);
    }

    // ✅ Make each icon span baseline-safe too
    el.style.display = 'inline-flex';
    el.style.alignItems = 'center';
    el.style.verticalAlign = 'middle';
    el.style.lineHeight = '1';

    if (el.parentNode !== pack) pack.appendChild(el);
    return el;
  }

  icon1 = ensureIcon(icon1, 'zest-i--plating');
  icon2 = ensureIcon(icon2, 'zest-i--plating2');
  icon3 = ensureIcon(icon3, 'zest-i--plating3');

  if (!has){
    hide(icon1); hide(icon2); hide(icon3);
    return;
  }

  if (plats.length === 1){
    icon1.style.display = '';
    icon1.innerHTML = platingSvgSingle(platingColors(plats[0]));
    hide(icon2);
    hide(icon3);
    return;
  }

  if (plats.length === 2){
    icon1.style.display = '';
    icon1.innerHTML = platingSvgSingle(platingColors(plats[0]));

    icon2.style.display = '';
    icon2.innerHTML = platingSvgSingle(platingColors(plats[1]));

    hide(icon3);
    return;
  }

  // 3 platings
  icon1.style.display = '';
  icon1.innerHTML = platingSvgSingle(platingColors(plats[0]));

  icon2.style.display = '';
  icon2.innerHTML = platingSvgSingle(platingColors(plats[1]));

  icon3.style.display = '';
  icon3.innerHTML = platingSvgSingle(platingColors(plats[2]));
}


  /* ============================================================
     🔒 LOCKED: ROPE COLOUR MAPPER
     ============================================================ */
  function ropeColor(name){
    const n = (name || '').toLowerCase();
    if (n.includes('mocha')) return '#6b4b3a';
    if (n.includes('chocolate')) return '#5a3a2a';
    if (n.includes('black')) return '#222222';
    if (n.includes('red')) return '#7d1531';
    if (n.includes('navy') || n.includes('blue')) return '#0b3f73';
    if (n.includes('white')) return '#9a9a9a';
    if (n.includes('grey') || n.includes('gray')) return '#6f6f6f';
    return '#6b4b3a';
  }

  /* ============================================================
     🔒 LOCKED: BEAD TYPE PARSER
     ============================================================ */
function beadType(desc){
  const n = (desc || '').toLowerCase();

  if (n.includes('heart bead')) return 'heart';
    // Donut bead (singular/plural + generic donut+bead)
  if (n.includes('donut bead') || n.includes('donut beads')) return 'donut';
  if (/\bdonut\b/.test(n) && /\bbeads?\b/.test(n)) return 'donut';

  if (n.includes('twist bead')) return 'twist';
  if (n.includes('drop bead')) return 'drop';
  if (n.includes('ball bead') || n === 'ball' || n.includes(' ball')) return 'ball';

  // ✅ NEW: star as special bead type (plating-inherit)
  // (keep this fairly specific)
  if (n.includes('star charm') || n === 'star') return 'star';

  return 'normal';
}


  function parseBeadParts(text){
    return (text || '')
      .toString()
      .split(',')
      .map(s => s.trim())
      .filter(Boolean)
      .slice(0, 4);
  }

  /* ============================================================
     🔒 LOCKED: bead hole (ALWAYS black)
     ============================================================ */
 function beadHoleSvg(cx){
  const x = (typeof cx === 'number') ? cx : 17.2;
  return `<circle cx="${x}" cy="12" r="1.25" fill="#000"></circle>`;
}

 /* ============================================================
PATCH ID: ZEST-PD-PATCH-20260216-05
TYPE: Feature
PURPOSE: Feature "Heart" (not "Heart bead") shows heart icon with NO hole
============================================================ */

/* --- BEGIN REPLACEMENT: beadSvg() --- */
function beadSvg(type, fill){
  const f = fill || '#7a1a2b';

  function normalHoleColor(fillHex){
    const L = _relLuma(fillHex);
    return (L < 0.14) ? '#e6e6e6' : '#000000';
  }

  function normalSideHoleSvg(fillHex){
    const hc = normalHoleColor(fillHex);
    return `<circle cx="17.2" cy="12" r="1.25" fill="${hc}"></circle>`;
  }

  if (type === 'heart'){
    // Heart bead (WITH hole) — canonical existing behaviour
    return `
      <svg class="zest-bead" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 21
                 C12 21, 3 15.5, 3 9.5
                 C3 6.4, 5.3 4.5, 7.9 4.5
                 C9.6 4.5, 11.1 5.4, 12 6.7
                 C12.9 5.4, 14.4 4.5, 16.1 4.5
                 C18.7 4.5, 21 6.4, 21 9.5
                 C21 15.5, 12 21, 12 21 Z"
              fill="${f}" stroke="#000" stroke-width="1.1"/>
        ${beadHoleSvg()}
      </svg>
    `;
  }

  if (type === 'heart_charm'){
    // Heart feature (NO hole) — new canonical feature behaviour
    return `
      <svg class="zest-bead" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 21
                 C12 21, 3 15.5, 3 9.5
                 C3 6.4, 5.3 4.5, 7.9 4.5
                 C9.6 4.5, 11.1 5.4, 12 6.7
                 C12.9 5.4, 14.4 4.5, 16.1 4.5
                 C18.7 4.5, 21 6.4, 21 9.5
                 C21 15.5, 12 21, 12 21 Z"
              fill="${f}" stroke="#000" stroke-width="1.1"/>
      </svg>
    `;
  }

  /* ============================================================
  PATCH ID: ZEST-PD-DONUT-SVG-CENTER-HOLE-v1
  TYPE: Bug fix
  PURPOSE:
  - Donut bead should be a true donut ring (center hole), not a side-hole bead
  - Center hole is solid black (distinct from plating icon)
  - Hole is ~10% smaller than the initial donut-hole target
  ROLLBACK:
  - Restore previous donut branch
  ============================================================ */
  if (type === 'donut'){
    const OUTER_R = 8.0;
    const HOLE_R  = 3.24; // 10% smaller vs 3.6 target
    return `
      <svg class="zest-bead" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="${OUTER_R}"
                fill="${f}" stroke="#000" stroke-width="1.1"></circle>

        <!-- Center hole (solid black) -->
        <circle cx="12" cy="12" r="${HOLE_R}" fill="#000"></circle>
      </svg>
    `;
  }


  if (type === 'star'){
    // 8-point star (no hole)
    return `
      <svg class="zest-bead" viewBox="0 0 24 24" aria-hidden="true">
        <path d="
          M12 2.8
          L13.6 8.1
          L18.5 5.5
          L15.9 10.4
          L21.2 12
          L15.9 13.6
          L18.5 18.5
          L13.6 15.9
          L12 21.2
          L10.4 15.9
          L5.5 18.5
          L8.1 13.6
          L2.8 12
          L8.1 10.4
          L5.5 5.5
          L10.4 8.1
          Z"
          fill="${f}"
          stroke="#000"
          stroke-width="1.1"
          stroke-linejoin="round"
        />
      </svg>
    `;
  }

  if (type === 'twist'){
    const r = 1.15;
    const beadRightEdge = 21.0;
    const cx = (beadRightEdge - r);
    const clipId = 'zestTwistClip_' + Math.random().toString(16).slice(2);

    const bodyPath = `
      M4.4 7.6
      Q4.4 5.8 6.4 5.8
      H18.9
      Q21.0 5.8 21.0 7.6
      V16.4
      Q21.0 18.2 18.9 18.2
      H6.4
      Q4.4 18.2 4.4 16.4
      Z
    `;

    return `
      <svg class="zest-bead" viewBox="0 0 24 24" aria-hidden="true">
        <defs>
          <clipPath id="${clipId}">
            <path d="${bodyPath}"></path>
          </clipPath>
        </defs>

        <path d="${bodyPath}" fill="${f}" stroke="#000" stroke-width="1.1"></path>

        <g clip-path="url(#${clipId})">
          <path d="M6.2 16.6 L19.2 7.4"
                fill="none"
                stroke="rgba(255,255,255,0.28)"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"></path>

          <path d="M6.8 17.2 L19.6 7.8"
                fill="none"
                stroke="rgba(0,0,0,0.28)"
                stroke-width="2.0"
                stroke-linecap="round"
                stroke-linejoin="round"></path>
        </g>

        <circle cx="${cx}" cy="12" r="${r}" fill="#000"></circle>
      </svg>
    `;
  }

   if (type === 'drop'){
    // Drop bead = ball bead WITHOUT hole
    return `
      <svg class="zest-bead" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="7.8"
                fill="${f}"
                stroke="#000"
                stroke-width="1.1"></circle>

        <circle cx="9.2" cy="9.1"
                r="2.2"
                fill="rgba(255,255,255,0.22)"></circle>
      </svg>
    `;
  }


  if (type === 'ball'){
    // Ball bead uses SAME icon as standard bead (normal)
    return `
      <svg class="zest-bead" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="7.8" fill="${f}" stroke="#000" stroke-width="1.1"></circle>
        <circle cx="9.2" cy="9.1" r="2.2" fill="rgba(255,255,255,0.22)"></circle>
        ${normalSideHoleSvg(f)}
      </svg>
    `;
  }

  // normal
  return `
    <svg class="zest-bead" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="7.8" fill="${f}" stroke="#000" stroke-width="1.1"></circle>
      <circle cx="9.2" cy="9.1" r="2.2" fill="rgba(255,255,255,0.22)"></circle>
      ${normalSideHoleSvg(f)}
    </svg>
  `;
}
/* --- END REPLACEMENT: beadSvg() --- */


  function ropeSvg(color){
    const base = (color || '#6b4b3a');

    function mixHex(a, b, t){
      const ah = (a || '').replace('#','');
      const bh = (b || '').replace('#','');
      if (ah.length !== 6 || bh.length !== 6) return a;

      const ar = parseInt(ah.slice(0,2),16), ag = parseInt(ah.slice(2,4),16), ab = parseInt(ah.slice(4,6),16);
      const br = parseInt(bh.slice(0,2),16), bg = parseInt(bh.slice(2,4),16), bb = parseInt(bh.slice(4,6),16);

      const rr = Math.round(ar + (br-ar)*t);
      const rg = Math.round(ag + (bg-ag)*t);
      const rb = Math.round(ab + (bb-ab)*t);

      return '#' + [rr,rg,rb].map(v => v.toString(16).padStart(2,'0')).join('');
    }

    const strandLight = mixHex(base, '#ffffff', 0.22);
    const strandDark  = mixHex(base, '#000000', 0.26);
    const wrapStroke  = strandLight;

    return `
      <svg class="zest-rope" viewBox="0 0 48 16" aria-hidden="true">
        <path d="M2 8 C6 3,10 3,14 8 C18 13,22 13,26 8 C30 3,34 3,38 8 C42 13,46 13,46 8"
          fill="none" stroke="${strandLight}" stroke-width="1.7"
          stroke-linecap="round" stroke-linejoin="round" opacity="0.70"></path>

        <path d="M2 8 C6 13,10 13,14 8 C18 3,22 3,26 8 C30 13,34 13,38 8 C42 3,46 3,46 8"
          fill="none" stroke="${strandDark}" stroke-width="2.9"
          stroke-linecap="round" stroke-linejoin="round"></path>

        <path d="M7.8 10.8 L12.0 6.2"   fill="none" stroke="${wrapStroke}" stroke-width="1.6" stroke-linecap="round" opacity="0.28"></path>
        <path d="M13.8 5.2 L18.0 9.8"   fill="none" stroke="${wrapStroke}" stroke-width="1.6" stroke-linecap="round" opacity="0.28"></path>
        <path d="M19.8 10.8 L24.0 6.2"  fill="none" stroke="${wrapStroke}" stroke-width="1.6" stroke-linecap="round" opacity="0.28"></path>
        <path d="M25.8 5.2 L30.0 9.8"   fill="none" stroke="${wrapStroke}" stroke-width="1.6" stroke-linecap="round" opacity="0.28"></path>
        <path d="M31.8 10.8 L36.0 6.2"  fill="none" stroke="${wrapStroke}" stroke-width="1.6" stroke-linecap="round" opacity="0.28"></path>
        <path d="M37.8 5.2 L42.0 9.8"   fill="none" stroke="${wrapStroke}" stroke-width="1.6" stroke-linecap="round" opacity="0.28"></path>
      </svg>
    `;
  }

  function applyVars(root, plating1Name, gem1Name, gem2Name, bead1Name, bead2Name, ropeName){
    const p1 = platingColors(plating1Name);

    root.style.setProperty('--plating-fill', p1.fill);
    root.style.setProperty('--plating-stroke', p1.stroke);
    root.style.setProperty('--plating-inner-stroke', p1.inner);
    root.style.setProperty('--plating-center-fill', p1.center || '#ffffff');

    function _gemLineForFill(fillHex){
      const L = _relLuma(fillHex);
      return (L < 0.20) ? '#e6e6e6' : '#000000';
    }

    const g1Fill = gemFill(gem1Name);
    const g2Fill = gemFill(gem2Name);

    root.style.setProperty('--gem1-fill', g1Fill);
    root.style.setProperty('--gem2-fill', g2Fill);
    root.style.setProperty('--gem1-line', _gemLineForFill(g1Fill));
    root.style.setProperty('--gem2-line', _gemLineForFill(g2Fill));

    root.style.setProperty('--bead1-fill', gemFill(bead1Name));
    root.style.setProperty('--bead2-fill', gemFill(bead2Name));

    root.style.setProperty('--rope-stroke', ropeColor(ropeName));
  }

  var ZEST_LOCK_DEBUG = false;

  function lockWarn(msg){
    if (!ZEST_LOCK_DEBUG) return;
    try { console.warn(msg); } catch(e){}
  }

  function lockCheck(root, platingText, bead1, bead2, ropeText){
    if (!ZEST_LOCK_DEBUG) return;

    function checkBead(field, value){
      const row = root.querySelector('.spec-item[data-field="'+field+'"]');
      const icon = row?.querySelector('.spec-icon');
      if ((value || '').trim() && row?.style.display !== 'none'){
        const hasSvg = !!icon?.querySelector('svg');
        if (!hasSvg) lockWarn('ZEST LOCK CHECK FAIL: '+field+' has value but no SVG icon injected.');
      }
    }
    checkBead('bead_1_desc', bead1);
    checkBead('bead_2_desc', bead2);

    const ropeRow = root.querySelector('.spec-item[data-field="rope"]');
    const ropeIcon = ropeRow?.querySelector('.spec-icon');
    if ((ropeText || '').trim() && ropeRow?.style.display !== 'none'){
      const svg = ropeIcon?.querySelector('svg.zest-rope');
      if (!svg) lockWarn('ZEST LOCK CHECK FAIL: rope has value but no rope SVG injected.');
    }
  }

  function zestGetParts(text){
    if (typeof parseBeadParts === 'function') return parseBeadParts(text);
    return (text || '')
      .toString()
      .split(',')
      .map(s => s.trim())
      .filter(Boolean)
      .slice(0, 4);
  }

  function zestNormalizeBeadPart(part){
    return (part || '').toString().trim();
  }

/* --- BEGIN REPLACEMENT: zestBeadType() --- */
function zestBeadType(part){
  const raw = (part || '').toString().trim();
  const p = raw.toLowerCase();

  // Bare descriptors
  if (p === 'drop') return 'drop';
  if (p === 'heart') return 'heart';
  if (p === 'twist') return 'twist';
  if (p === 'donut') return 'donut';
  if (p === 'ball') return 'ball';

  // ✅ NEW: boho bead synonym for donut
  if (/\bboho\b/.test(p)) return 'donut';

  // ✅ NEW: silver bead synonym for ball bead
  if (p === 'silver' || /\bsilver bead(s)?\b/.test(p)) return 'ball';

  // Donut robustness
  if (/\bdonut\b/.test(p) && /\bbead(s)?\b/.test(p)) return 'donut';

  // Star token
  if (p === 'star' || p === 'star charm') return 'star';

  // Existing special-case
  if (p.includes('sterling silver')) return 'ball';

  return beadType(raw);
}
/* --- END REPLACEMENT: zestBeadType() --- */


function zestBeadFill(part){
  const raw = (part || '').toString().trim();
  const n = raw.toLowerCase();

  // Pearl
  if (n.includes('pearl')) return '#efe6d2';

  // ============================================================
  // Z’EST stylised bead expansions
  // ============================================================
  if (n.includes('green malachite')) return '#1E8A5A';
  if (n.includes('pink opal')) return '#E3A6B8';
  if (n.includes('green agate')) return '#2F9A63';
  if (n.includes('green tourmaline')) return '#1C9B72';
  if (n.includes('light brown sun stone') || n.includes('light brown sunstone')) return '#C69563';
  if (n.includes('purple jasper')) return '#8A67B8';
  if (n.includes('black tourmaline')) return '#1E1E1E';
  // Explicit bead colour overrides
  if (n.includes('black onyx') || n.includes('onyx')) return '#1a1a1a';
  if (n === 'black' || n.includes('black bead') || n.includes(' black')) return '#1a1a1a';

  if (
    n.includes('multi brown') ||
    n.includes('multi-brown') ||
    n.includes('mixed brown')
  ) return '#7b5a34';

  if (
    n === 'tiger' ||
    n.includes('tiger eye') ||
    n.includes('tiger bead') ||
    n.includes('brown tiger')
  ) return '#a8742a';

  if (n.includes('white zirconium') || n.includes('zircon')) return '#ffffff';

  if (n.includes('amazinite') || n.includes('amazineite') || n.includes('amazonite')) return '#7fd3e6';
  if (n.includes('lapis')) return '#1b3f8b';

  // ✅ UPDATED: Turquoise bead colour (reference-adjusted)
  if (n.includes('turquoise')) return '#1f8f8b';

  if (n.includes('yellow')) return '#c2b73a';

  // Fallback to gem colour logic
  const c = gemFill(raw);

  if (c === '#7a1a2b') return '#ffffff';

  return c;
}

function zestSegmentedBeadSvg(fills){
  const cols = (fills || []).filter(Boolean).slice(0, 4);
  if (!cols.length) return '';

  // Single bead → normal render
  if (cols.length === 1){
    return beadSvg('normal', cols[0]);
  }

  const cx = 12, cy = 12;
  const r = 8.1;

  function polarToXY(angleRad){
    return { x: cx + r * Math.cos(angleRad), y: cy + r * Math.sin(angleRad) };
  }

  function wedgePath(a0, a1){
    const p0 = polarToXY(a0);
    const p1 = polarToXY(a1);
    const largeArc = (a1 - a0) > Math.PI ? 1 : 0;
    return `M ${cx} ${cy} L ${p0.x.toFixed(3)} ${p0.y.toFixed(3)} A ${r} ${r} 0 ${largeArc} 1 ${p1.x.toFixed(3)} ${p1.y.toFixed(3)} Z`;
  }

  const n = cols.length;
  const startBase = -Math.PI / 2;
  const step = (Math.PI * 2) / n;

  const wedges = cols.map((color, i) => {
    const a0 = startBase + step * i;
    const a1 = startBase + step * (i + 1);
    return `<path d="${wedgePath(a0, a1)}" fill="${color}" stroke="#000" stroke-width="0.9" stroke-linejoin="round"></path>`;
  }).join('');

  // Hole logic
  let holeFill = '#000'; // default safe

  if (n !== 4){
    // Existing dynamic contrast logic for 2/3 splits
    const holeAngle = 0;
    let holeIndex = 0;
    for (let i = 0; i < n; i++){
      const a0 = startBase + step * i;
      const a1 = startBase + step * (i + 1);
      if (holeAngle >= a0 && holeAngle < a1){ holeIndex = i; break; }
    }

    const segmentColor = cols[holeIndex] || cols[0];
    const isDark = _relLuma(segmentColor) < 0.45;
    holeFill = isDark ? '#fff' : '#000';
  }
  // If n === 4 → holeFill remains black

  const hole = `<circle cx="17.2" cy="12" r="1.25" fill="${holeFill}"></circle>`;
  const outer = `<circle cx="${cx}" cy="${cy}" r="${r}" fill="none" stroke="#000" stroke-width="1.1"></circle>`;

  return `
    <svg class="zest-bead" viewBox="0 0 24 24" aria-hidden="true">
      ${wedges}
      ${outer}
      ${hole}
    </svg>
  `;
}

function zestIconsHtmlFromParts(parts, platingName){
  const seen = new Set();

  return (parts || []).map(partRaw => {
    const part = zestNormalizeBeadPart(partRaw);
    const t = zestBeadType(part);

    const pfill = platingColors(platingName).fill;
    const fill = (t === 'normal') ? zestBeadFill(part) : pfill;

    // ✅ De-dupe rule for icons within a single attribute row:
    // - normal beads de-dupe by fill (Pearl sizes collapse)
    // - specials de-dupe by type (all "ball" collapse etc)
    const key = (t === 'normal') ? (`normal:${fill}`) : (`special:${t}`);
    if (seen.has(key)) return '';

    seen.add(key);
    return beadSvg(t, fill);
  }).join('');
}

/* ============================================================
PATCH ID: ZEST-PD-FEATURE-SEGMENTS-ONEICON-v1
TYPE: Feature
PURPOSE:
- Feature supports multiple values split by comma / "and" / "&"
- EACH segment generates at most ONE icon (winner-takes-all)
- Adds 2 special feature icons:
  1) Disc/Tag (small disc, plating-inherit, side hole)
  2) Z’EST Tag (plating-sized disc, side hole, Z’EST text in dark shade)
- Feature icons always appear on summary row
ROLLBACK:
- Restore previous setFeatureIcon() implementation
============================================================ */

/* --- BEGIN REPLACEMENT: setFeatureIcon() --- */
function setFeatureIcon(root, featureText, platingNameForFeature){

  const fRaw = (featureText || '').toString().trim();
  const hasAny = fRaw.length > 0;

  const featureRow = root.querySelector('.spec-item[data-field="feature"]');

  let rowIcon =
    featureRow?.querySelector('.spec-icon.zest-i--feature') ||
    featureRow?.querySelector('.spec-icon');

  // Defensive: create row icon placeholder if missing
  if (featureRow && !rowIcon){
    const valueEl = featureRow.querySelector('.spec-value');
    rowIcon = document.createElement('span');
    rowIcon.className = 'spec-icon zest-i--feature';
    rowIcon.setAttribute('aria-hidden', 'true');

    if (valueEl && valueEl.parentNode){
      valueEl.parentNode.insertBefore(rowIcon, valueEl.nextSibling);
    } else {
      featureRow.appendChild(rowIcon);
    }
  }

  const summaryRow = root.querySelector('.zest-summary-icons');

  let headerIcon =
    root.querySelector('.zest-summary-icons .zest-i--feature') ||
    root.querySelector('.zest-summary-icons [data-icon="feature"]');

  // Defensive: create summary slot if missing
  if (summaryRow && !headerIcon){
    headerIcon = document.createElement('span');
    headerIcon.className = 'zest-i zest-i--feature';
    headerIcon.setAttribute('data-icon', 'feature');
    headerIcon.setAttribute('aria-hidden', 'true');
    summaryRow.insertBefore(headerIcon, summaryRow.firstChild);
  }

  if (rowIcon) rowIcon.style.display = hasAny ? '' : 'none';
  if (headerIcon) headerIcon.style.display = hasAny ? '' : 'none';

  if (!hasAny){
    if (rowIcon) rowIcon.innerHTML = '';
    if (headerIcon) headerIcon.innerHTML = '';
    return;
  }

  const pfill = platingColors(platingNameForFeature || '').fill;

  function getGem1Fill(){
    try {
      const css = getComputedStyle(root).getPropertyValue('--gem1-fill').trim();
      if (css) return css;
    } catch(e){}
    return '#7a1a2b';
  }

  function splitSegments(txt){
  // commas OR "and" OR "&" OR "with" (case-insensitive), trim empties
  return (txt || '')
    .split(/\s*(?:,|\band\b|&|\bwith\b)\s*/i)
    .map(s => s.trim())
    .filter(Boolean);
}

  function darkenHex(hex, t){
    // mix toward black by t (0..1). deterministic + safe fallback
    const h = (hex || '').toString().replace('#','').trim();
    if (h.length !== 6) return '#333333';
    const r = parseInt(h.slice(0,2),16);
    const g = parseInt(h.slice(2,4),16);
    const b = parseInt(h.slice(4,6),16);
    if (Number.isNaN(r)||Number.isNaN(g)||Number.isNaN(b)) return '#333333';
    const rr = Math.max(0, Math.min(255, Math.round(r * (1 - t))));
    const gg = Math.max(0, Math.min(255, Math.round(g * (1 - t))));
    const bb = Math.max(0, Math.min(255, Math.round(b * (1 - t))));
    return '#' + [rr,gg,bb].map(v => v.toString(16).padStart(2,'0')).join('');
  }

  /* ============================================================
  PATCH ID: ZEST-PD-DISC-UNIFY-WITH-ZEST-v1
  TYPE: Feature refinement
  PURPOSE:
  - Make Disc/Tag icon identical to ZEST tag base
  - Same size as plating icon
  - Same stroke width as bead outline (1.1)
  - Same top-centre hole position
  - No internal text
  ============================================================ */
  function discTagSvg(platingFillHex){

    const fill = platingFillHex || '#dcdcdc';

    const OUTER_R = 8.8;
    const STROKE_W = 1.1;
    const HOLE_R = 1.25;
    const HOLE_CY = 6.2;

    return `
      <svg class="zest-feature" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="${OUTER_R}"
                fill="${fill}"
                stroke="#000"
                stroke-width="${STROKE_W}"></circle>

        <circle cx="12" cy="${HOLE_CY}"
                r="${HOLE_R}"
                fill="#000"></circle>
      </svg>
    `;
  }

 /* ============================================================
 PATCH ID: ZEST-PD-ZESTTAG-PATH-v2
 TYPE: Bug fix
 PURPOSE:
 - Keep disc + hole geometry identical
 - Replace stroked letter-lines with filled geometry for crisp small-size rendering
 ============================================================ */
function zestTagSvg(fillHex){
  const fill = fillHex || '#dcdcdc';
  const R = 9.0;
  const ink = darkenHex(fill, 0.62);

  const OUTER_STROKE = 1.1;

  const HOLE_CX = 12.0;
  const HOLE_CY = 7.6;
  const HOLE_R  = 1.25;

  return `
    <svg class="zest-feature" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="${R}"
              fill="${fill}"
              stroke="#000"
              stroke-width="${OUTER_STROKE}"></circle>

      <!-- hole: top-center -->
      <circle cx="${HOLE_CX}" cy="${HOLE_CY}" r="${HOLE_R}" fill="#000"></circle>

      <!-- Z’EST (filled geometry for crispness) -->
        <!-- Z’EST (engraved-style path version) -->
        <!-- scaled + centered so it never runs off the disc -->
        <g fill="${ink}" stroke="none"
           transform="translate(12 12.9) scale(0.96) translate(-12 -12.9) translate(-1.65 -0.20)">

          <!-- Z -->
          <path d="
            M7.0 11.6
            H9.6
            L7.2 14.7
            H9.9
            V15.6
            H6.7
            L9.1 12.5
            H7.0
            Z" />

          <!-- Apostrophe -->
          <path d="
            M10.45 11.15
            C10.25 11.75 10.20 12.25 10.35 12.85
            L10.95 12.55
            C10.82 12.05 10.88 11.70 11.05 11.30
            Z" />

          <!-- E -->
          <path d="
            M11.3 11.6
            H13.9
            V12.4
            H12.1
            V13.1
            H13.7
            V13.9
            H12.1
            V14.8
            H13.9
            V15.6
            H11.3
            Z" />

          <!-- S (FIXED: not mirrored, smoother like reference) -->
          <path d="
            M16.7 11.55
            C15.7 11.30 14.85 11.70 14.85 12.55
            C14.85 13.10 15.20 13.45 15.95 13.65
            C16.65 13.83 16.95 14.05 16.95 14.45
            C16.95 14.95 16.45 15.15 15.95 15.15
            C15.40 15.15 15.00 14.90 14.95 14.40
            H14.10
            C14.20 15.45 15.10 15.85 16.00 15.85
            C17.05 15.85 17.85 15.35 17.85 14.40
            C17.85 13.75 17.45 13.35 16.55 13.10
            C15.85 12.90 15.70 12.75 15.70 12.45
            C15.70 12.05 16.05 11.90 16.55 12.00
            C16.90 12.07 17.20 12.25 17.30 12.55
            H18.10
            C17.95 12.00 17.45 11.70 16.7 11.55
            Z" />

          <!-- T -->
          <path d="
            M18.1 11.6
            H20.8
            V12.4
            H19.85
            V15.6
            H19.05
            V12.4
            H18.1
            Z" />

        </g>

    </svg>
  `;
}

/* ============================================================
PATCH ID: ZEST-PD-ATOMIC-TAG-KISS-RIM-v2
TYPE: Feature refinement
PURPOSE:
- Atomic design visually “kisses” inner rim
- 25% darker plating tone for rim + design
- Interior fill white
- No hole
ROLLBACK:
- Restore previous atomicTagSvg()
============================================================ */
function atomicTagSvg(platingFillHex){

  const fill  = platingFillHex || '#dcdcdc';
  const metal = darkenHex(fill, 0.25); // 25% darker

  const OUTER_R  = 8.8;
  const STROKE_W = 1.1;

  const CX = 12;
  const CY = 12;

  // Maximum safe radius inside rim stroke
  const SAFE_INNER_R = OUTER_R - (STROKE_W / 2);

  // Push orbits almost to the rim (tiny safety margin)
  const ORBIT_RX = SAFE_INNER_R - 0.05;  // ← kissing distance
  const ORBIT_RY = 3.45;

  return `
    <svg class="zest-feature" viewBox="0 0 24 24" aria-hidden="true">

      <!-- Outer disc -->
      <circle cx="${CX}" cy="${CY}" r="${OUTER_R}"
              fill="#ffffff"
              stroke="${metal}"
              stroke-width="${STROKE_W}"></circle>

      <!-- Atomic symbol -->
      <g fill="none"
         stroke="${metal}"
         stroke-width="1.2"
         stroke-linecap="round"
         shape-rendering="geometricPrecision">

        <ellipse cx="${CX}" cy="${CY}"
                 rx="${ORBIT_RX}" ry="${ORBIT_RY}"
                 transform="rotate(20 ${CX} ${CY})"></ellipse>

        <ellipse cx="${CX}" cy="${CY}"
                 rx="${ORBIT_RX}" ry="${ORBIT_RY}"
                 transform="rotate(-20 ${CX} ${CY})"></ellipse>

        <ellipse cx="${CX}" cy="${CY}"
                 rx="${ORBIT_RX}" ry="${ORBIT_RY}"
                 transform="rotate(90 ${CX} ${CY})"></ellipse>
      </g>

      <circle cx="${CX}" cy="${CY}" r="1.35"
              fill="${metal}"></circle>

    </svg>
  `;
}

/* ============================================================
PATCH ID: ZEST-PD-PATCH-20260219-PEAR-SPOKES-v2
TYPE: Bug fix
PURPOSE:
- Pear: keep INNER_Y_OFFSET default at -0.5 (standing rule)
- Internal lines (inner outline + spokes) now 30% thinner
- Spokes “kiss” INNER edge of outer stroke (no crossing)
- Spoke endpoints follow inner transform (scale + y-offset)
ROLLBACK:
- Restore previous pearGemSvg()
============================================================ */
function pearGemSvg(gemFillHex){

  const fill = gemFillHex || '#8b1a2b';
  const lineStroke = (_relLuma(fill) < 0.20) ? '#e6e6e6' : '#000000';

  // Pear outer path (existing geometry)
  const outerPath = `
    M12 3
    C17 6, 21 9, 12 21
    C3 9, 7 6, 12 3 Z
  `;

  // Inner: base as before
  const INNER_SCALE = 0.58 * 0.80; // 0.464

  // ✅ Standing rule
  const INNER_Y_OFFSET = -0.5;

  // Strokes
  const OUTER_STROKE = 1.1;

  // ✅ 30% thinner vs base 1.3
  const INNER_STROKE = 1.3 * 0.70; // 0.91

  const cx = 12;
  const cy = 12;

  // Flip so pointy end is at TOP (applies to everything inside group)
  const flipTf = `rotate(180 12 12)`;

  // Inner transform for the inner outline path
  const innerTf =
    `translate(${cx} ${cy}) ` +
    `scale(${INNER_SCALE}) ` +
    `translate(${-cx} ${-cy}) ` +
    `translate(0 ${INNER_Y_OFFSET})`;

  // Apply the same scale-about-center + Y offset to any point
  function applyInnerTransform(pOuter){
    return {
      x: cx + (pOuter.x - cx) * INNER_SCALE,
      y: cy + (pOuter.y - cy) * INNER_SCALE + INNER_Y_OFFSET
    };
  }

  // Start point should kiss INNER edge of outer stroke, with optical safety pad
  function insetToInnerEdgeOfOuterStroke(pOuter){
    const dx = cx - pOuter.x;
    const dy = cy - pOuter.y;
    const dist = Math.sqrt(dx*dx + dy*dy) || 1;

    // Move inward enough that the round cap doesn't overlap the black outline
    const PAD = 0.18; // optical safety pad (prevents “crossing” look)
    const inset = (OUTER_STROKE / 2) + (INNER_STROKE / 2) + PAD;
    const t = inset / dist;

    return {
      x: pOuter.x + dx * t,
      y: pOuter.y + dy * t
    };
  }

  function spokeLine(pOuterAnchor){
    const start = insetToInnerEdgeOfOuterStroke(pOuterAnchor);
    const end   = applyInnerTransform(pOuterAnchor);

    return `
      <line x1="${start.x.toFixed(3)}" y1="${start.y.toFixed(3)}"
            x2="${end.x.toFixed(3)}"   y2="${end.y.toFixed(3)}"
            stroke="${lineStroke}"
            stroke-width="${INNER_STROKE}"
            stroke-linecap="round"
            vector-effect="non-scaling-stroke"
            opacity="0.95"></line>
    `;
  }

  // Spoke anchors (approx points on pear silhouette)
  // NOTE: Defined in *unflipped* space; group transform flips visually.
  const NW = { x: 9.0,  y: 6.2 };
  const NE = { x: 15.0, y: 6.2 };
  const W  = { x: 7.3,  y: 12.0 };
  const E  = { x: 16.7, y: 12.0 };
  const SW = { x: 9.4,  y: 17.0 };
  const SE = { x: 14.6, y: 17.0 };

  return `
    <svg class="zest-feature" viewBox="0 0 24 24" aria-hidden="true">
      <g transform="${flipTf}">

        <!-- 1) Outer fill -->
        <path d="${outerPath}" fill="${fill}" stroke="none"></path>

        <!-- 2) Inner outline -->
        <path d="${outerPath}"
              transform="${innerTf}"
              fill="none"
              stroke="${lineStroke}"
              stroke-width="${INNER_STROKE}"
              stroke-linejoin="round"
              vector-effect="non-scaling-stroke"
              opacity="0.95"></path>

        <!-- 3) Spokes -->
        ${spokeLine(NW)}
        ${spokeLine(NE)}
        ${spokeLine(E)}
        ${spokeLine(W)}
        ${spokeLine(SE)}
        ${spokeLine(SW)}

        <!-- 4) Outer rim stroke on top -->
        <path d="${outerPath}"
              fill="none"
              stroke="#000"
              stroke-width="${OUTER_STROKE}"
              stroke-linejoin="round"
              vector-effect="non-scaling-stroke"></path>

      </g>
    </svg>
  `;
}


/* ============================================================
PATCH ID: ZEST-PD-PATCH-20260219-FEATURE-PEAR-ORDER-AND-PENDANT-v1
TYPE: Bug fix
PURPOSE:
- Pear gem triggers ONLY when (pear|tear|teardrop) appears BEFORE (gem|jewel|stone)
- Prevents "Gem ... Teardrop ..." from incorrectly becoming pear gem
- Adds teardrop pendant feature when shape-word is followed by "pendant"
ROLLBACK:
- Restore your previous winnerForSegment() and remove teardropPendantSvg()
============================================================ */

function teardropPendantSvg(platingFillHex){
  const fill = platingFillHex || '#dcdcdc';

  const outerPath = `
    M12 3
    C17 6, 21 9, 12 21
    C3 9, 7 6, 12 3 Z
  `;

  const OUTER_STROKE = 1.1;

  // Flip so pointy end appears at TOP
  const flipTf = `rotate(180 12 12)`;

  // --- Hole placement (inset from point) ---
  const HOLE_VISIBLE_Y = 8.0;         // visually correct inset
  const HOLE_CX = 12.0;
  const HOLE_CY = 24 - HOLE_VISIBLE_Y;

  // ✅ Same radius as bead hole
  const HOLE_R = 1.25;

  return `
    <svg class="zest-feature" viewBox="0 0 24 24" aria-hidden="true">
      <g transform="${flipTf}">

        <!-- Fill -->
        <path d="${outerPath}" fill="${fill}" stroke="none"></path>

        <!-- Simple pendant hole -->
<circle cx="${HOLE_CX}" cy="${HOLE_CY}"
        r="${HOLE_R}"
        fill="#000"></circle>

        <!-- Outer rim -->
        <path d="${outerPath}"
              fill="none"
              stroke="#000"
              stroke-width="${OUTER_STROKE}"
              stroke-linejoin="round"
              vector-effect="non-scaling-stroke"></path>

      </g>
    </svg>
  `;
}



/* ============================================================
PATCH ID: ZEST-PD-PATCH-20260219-SQUARE-GEM-v1
TYPE: Feature
PURPOSE:
- New special Feature gem: Square Gem
- Triggered by “square” followed by (optional “bumpy”) + (gem|stone|jewel)
- Inner facet square + 4 corner spokes (outer corners → inner corners)
- Same fill + dark-gem line rule as other gems
ROLLBACK:
- Remove squareGemSvg() and its winnerForSegment() hook + suppression hook
============================================================ */
function squareGemSvg(gemFillHex){

  const fill = gemFillHex || '#8b1a2b';
  const lineStroke = (_relLuma(fill) < 0.20) ? '#e6e6e6' : '#000000';

  const cx = 12;
  const cy = 12;

  // Simple square (clean at small size)
  const outerPath = `
    M6 6
    H18
    V18
    H6
    Z
  `;

  const OUTER_STROKE = 1.1;

  // Match “thin internal lines” vibe (same as pear after 30% thin)
  const INNER_STROKE = 1.3 * 0.70; // 0.91

  // Inner square scale
  const INNER_SCALE = 0.60;
  const innerTf = `translate(${cx} ${cy}) scale(${INNER_SCALE}) translate(${-cx} ${-cy})`;

  // Helpers
  function innerPoint(pOuter){
    return {
      x: cx + (pOuter.x - cx) * INNER_SCALE,
      y: cy + (pOuter.y - cy) * INNER_SCALE
    };
  }

  // Spoke start should “kiss” the inner edge of the outer stroke
  function insetToInnerEdgeOfOuterStroke(pOuter){
    const dx = cx - pOuter.x;
    const dy = cy - pOuter.y;
    const dist = Math.sqrt(dx*dx + dy*dy) || 1;

    const PAD = 0.18;
    const inset = (OUTER_STROKE / 2) + (INNER_STROKE / 2) + PAD;
    const t = inset / dist;

    return {
      x: pOuter.x + dx * t,
      y: pOuter.y + dy * t
    };
  }

  function spokeLine(pOuterCorner){
    const start = insetToInnerEdgeOfOuterStroke(pOuterCorner);
    const end   = innerPoint(pOuterCorner);

    return `
      <line x1="${start.x.toFixed(3)}" y1="${start.y.toFixed(3)}"
            x2="${end.x.toFixed(3)}"   y2="${end.y.toFixed(3)}"
            stroke="${lineStroke}"
            stroke-width="${INNER_STROKE}"
            stroke-linecap="round"
            vector-effect="non-scaling-stroke"
            opacity="0.95"></line>
    `;
  }

  // Outer corners
  const NW = { x: 6.0,  y: 6.0  };
  const NE = { x: 18.0, y: 6.0  };
  const SE = { x: 18.0, y: 18.0 };
  const SW = { x: 6.0,  y: 18.0 };

  return `
    <svg class="zest-feature" viewBox="0 0 24 24" aria-hidden="true">

      <!-- outer -->
      <path d="${outerPath}"
            fill="${fill}"
            stroke="#000"
            stroke-width="${OUTER_STROKE}"
            stroke-linejoin="miter"
            vector-effect="non-scaling-stroke"></path>

      <!-- inner -->
      <path d="${outerPath}"
            transform="${innerTf}"
            fill="none"
            stroke="${lineStroke}"
            stroke-width="${INNER_STROKE}"
            stroke-linejoin="miter"
            vector-effect="non-scaling-stroke"
            opacity="0.95"></path>

      <!-- spokes -->
      ${spokeLine(NW)}
      ${spokeLine(NE)}
      ${spokeLine(SE)}
      ${spokeLine(SW)}

    </svg>
  `;


}function fivePointStarSvg(platingFillHex){

  const fill = platingFillHex || '#dcdcdc';

  return `
    <svg class="zest-feature" viewBox="0 0 24 24" aria-hidden="true">
      <path d="
        M12 3.5
        L14.6 9.2
        L20.8 9.8
        L16.1 13.8
        L17.6 20
        L12 16.8
        L6.4 20
        L7.9 13.8
        L3.2 9.8
        L9.4 9.2
        Z"
        fill="${fill}"
        stroke="#000"
        stroke-width="1.1"
        stroke-linejoin="round"
      />
    </svg>
  `;
}



function marquiseGemSvg(gemFillHex){

  const fill = gemFillHex || '#8b1a2b';
  const lineStroke = (_relLuma(fill) < 0.20) ? '#e6e6e6' : '#000000';

  const outerPath = `
    M12 3
    L15.6 6.3
    L17.8 12
    L15.6 17.7
    L12 21
    L8.4 17.7
    L6.2 12
    L8.4 6.3
    Z
  `;

  const INNER_SCALE = 0.464;
  const innerTf = `translate(12 12) scale(${INNER_SCALE}) translate(-12 -12)`;

  const OUTER_STROKE = 0.95;

  // ✅ 20% thinner than 0.65
  const INNER_STROKE = 0.52;

  const cx = 12;
  const cy = 12;

  // Outer anchors
  const N  = { x: 12.0, y: 3.0  };
  const NW = { x: 8.4,  y: 6.3 };
  const NE = { x: 15.6, y: 6.3 };
  const E  = { x: 17.8, y: 12.0 };
  const W  = { x: 6.2,  y: 12.0 };
  const SE = { x: 15.6, y: 17.7 };
  const SW = { x: 8.4,  y: 17.7 };
  const S  = { x: 12.0, y: 21.0 };

  function innerPoint(xOuter, yOuter){
    return {
      x: cx + (xOuter - cx) * INNER_SCALE,
      y: cy + (yOuter - cy) * INNER_SCALE
    };
  }

  // Move a point toward the center by a fixed amount (viewBox units)
  function nudgeTowardCenter(p, amount){
    const dx = cx - p.x;
    const dy = cy - p.y;
    const dist = Math.sqrt(dx*dx + dy*dy) || 1;
    const t = amount / dist;
    return { x: p.x + dx * t, y: p.y + dy * t };
  }

  // Start point kisses INNER edge of the OUTER stroke (and avoids crossing it)
  function insetToInnerEdgeOfOuterStroke(pOuter){
    const dx = cx - pOuter.x;
    const dy = cy - pOuter.y;
    const dist = Math.sqrt(dx*dx + dy*dy) || 1;

    const PAD = 0.20; // optical safety pad

    // move inward enough that the round cap doesn't overlap the black outline
    const inset = (OUTER_STROKE / 2) + (INNER_STROKE / 2) + PAD;
    const t = inset / dist;

    return {
      x: pOuter.x + dx * t,
      y: pOuter.y + dy * t
    };
  }

  function spokeLine(pOuterVertex, opts){
    const o = opts || {};
    const start = insetToInnerEdgeOfOuterStroke(pOuterVertex);

    // Default: end exactly on inner outline direction
    let end = innerPoint(pOuterVertex.x, pOuterVertex.y);

    // ✅ For N/S: stop *just before* the inner outline to avoid double-stroking at the tips
    if (o.endInset && o.endInset > 0){
      end = nudgeTowardCenter(end, o.endInset);
    }

    const cap = o.cap || 'round';

    return `
      <line x1="${start.x.toFixed(3)}" y1="${start.y.toFixed(3)}"
            x2="${end.x.toFixed(3)}"   y2="${end.y.toFixed(3)}"
            stroke="${lineStroke}"
            stroke-width="${INNER_STROKE}"
            stroke-linecap="${cap}"
            vector-effect="non-scaling-stroke"
            opacity="0.95"></line>
    `;
  }

  // Small inset so N/S visually “kiss” inner outline but don’t overlap it
  const TIP_END_INSET = (INNER_STROKE / 2) + 0.12;

  return `
    <svg class="zest-feature" viewBox="0 0 24 24" aria-hidden="true">

      <!-- outer -->
      <path d="${outerPath}"
            fill="${fill}"
            stroke="#000"
            stroke-width="${OUTER_STROKE}"
            stroke-linejoin="miter"
            vector-effect="non-scaling-stroke"></path>

      <!-- inner -->
      <path d="${outerPath}"
            transform="${innerTf}"
            fill="none"
            stroke="${lineStroke}"
            stroke-width="${INNER_STROKE}"
            stroke-linejoin="miter"
            vector-effect="non-scaling-stroke"
            opacity="0.95"></path>

      <!-- spokes -->
      ${spokeLine(N,  { cap:'butt', endInset: TIP_END_INSET })}
      ${spokeLine(NW)}
      ${spokeLine(NE)}
      ${spokeLine(E)}
      ${spokeLine(W)}
      ${spokeLine(SE)}
      ${spokeLine(SW)}
      ${spokeLine(S,  { cap:'butt', endInset: TIP_END_INSET })}

    </svg>
  `;
}







  // Existing: heart gem SVG (your current look)
  function heartGemSvg(gemFillHex){
    const fill = gemFillHex || '#8b1a2b';
    const lineStroke = (_relLuma(fill) < 0.20) ? '#e6e6e6' : '#000000';

    const outerPath = `
      M12 21
      C12 21, 3 15.5, 3 9.5
      C3 6.4, 5.3 4.5, 7.9 4.5
      C9.6 4.5, 11.1 5.4, 12 6.7
      C12.9 5.4, 14.4 4.5, 16.1 4.5
      C18.7 4.5, 21 6.4, 21 9.5
      C21 15.5, 12 21, 12 21 Z
    `;

    const INNER_SCALE = 0.56 * 0.95;
    const innerTf = `translate(12 12) scale(${INNER_SCALE}) translate(-12 -12)`;

    const OUTER_STROKE = 1.1;
    const INNER_STROKE = 1.3;
    const SPOKE_STROKE = 0.8;

    const cx = 12;
    const cy = 12;

    const START_RATIO = 0.90;
    const START_RATIO_LOWER = 0.75;
    const END_RATIO = INNER_SCALE + 0.02;

    function spoke(theta, startRatio){
      const dx = Math.cos(theta);
      const dy = Math.sin(theta);

      const xOuter = cx + dx * 9;
      const yOuter = cy + dy * 9;

      const sr = (typeof startRatio === 'number') ? startRatio : START_RATIO;

      const x1 = cx + (xOuter - cx) * sr;
      const y1 = cy + (yOuter - cy) * sr;

      const x2 = cx + (xOuter - cx) * END_RATIO;
      const y2 = cy + (yOuter - cy) * END_RATIO;

      return `
        <line x1="${x1.toFixed(3)}" y1="${y1.toFixed(3)}"
              x2="${x2.toFixed(3)}" y2="${y2.toFixed(3)}"
              stroke="${lineStroke}"
              stroke-width="${SPOKE_STROKE}"
              stroke-linecap="round"
              opacity="0.95"></line>
      `;
    }

    const spokes = [
      { d: -45 },
      { d:   0 },
      { d:  45, sr: START_RATIO_LOWER },
      { d:  90 },
      { d: 135, sr: START_RATIO_LOWER },
      { d: 180 },
      { d: -135 }
    ].map(o => spoke(o.d * Math.PI/180, o.sr)).join('');

    return `
      <svg class="zest-feature" viewBox="0 0 24 24" aria-hidden="true">
        <path d="${outerPath}"
              fill="${fill}"
              stroke="#000"
              stroke-width="${OUTER_STROKE}"
              stroke-linejoin="round"></path>

        <path d="${outerPath}"
              transform="${innerTf}"
              fill="none"
              stroke="${lineStroke}"
              stroke-width="${INNER_STROKE}"
              stroke-linejoin="round"
              opacity="0.95"></path>

        ${spokes}
      </svg>
    `;
  }

  /* ============================================================
PATCH ID: ZEST-PD-HEART-INLAY-WHITE-CENTRE-v1
TYPE: Bug fix
PURPOSE:
- Heart Shaped Cutout should render:
    • Outer disc = plating fill (pfill)
    • Inner heart = white
    • Black outline preserved
ROLLBACK:
- Restore previous heartInlaySvg() implementation
============================================================ */

function heartInlaySvg(pfill){
  return `
  <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
    <!-- Outer disc (UNCHANGED) -->
    <circle cx="12" cy="12" r="8" fill="${pfill}" stroke="#000" stroke-width="1.5"/>

    <!-- White heart cutout (scaled down ~5% + nudged down a touch) -->
    <g transform="translate(12 12) translate(0 0.35) scale(0.95) translate(-12 -12)">
      <path d="
        M12 16.8
        C9.5 13.6 7.8 12.1 7.8 10.3
        C7.8 8.9 8.9 7.9 10.2 7.9
        C11 7.9 11.7 8.3 12 9
        C12.3 8.3 13 7.9 13.8 7.9
        C15.1 7.9 16.2 8.9 16.2 10.3
        C16.2 12.1 14.5 13.6 12 15.8
        Z"
        fill="#ffffff"
        stroke="#000"
        stroke-width="1.2"
        stroke-linejoin="round"
      />
    </g>
  </svg>
  `;
}

/* ============================================================
PATCH ID: ZEST-PD-PATCH-20260220-FEATURE-PLURALS-MULTICAST-v1
TYPE: Bug fix
PURPOSE:
- Make Feature trigger matching tolerant to plurals and common variants
- Fix: "Heart Shaped Cutouts" now triggers heart cutout/inlay icon
- Broaden: gem/jewel/stone plural forms across special-gem triggers
- Keep priority order unchanged (prevents unintended icon shifts)
ROLLBACK:
- Restore previous winnerForSegment() implementation
============================================================ */

/* --- BEGIN REPLACEMENT: winnerForSegment() --- */
function winnerForSegment(segRaw){
  const seg = (segRaw || '').trim();
  const s = seg.toLowerCase();

  // Shared word groups (plural-safe)
  const RX_GEM_WORD   = /\b(?:gem|gems|jewel|jewels|stone|stones)\b/;
  const RX_PENDANT    = /\bpendants?\b/;
  const RX_BEAD_WORD  = /\bbeads?\b/;

  // Priority 1: Z’EST Tag
  const isZest = /\bz[\u2019']?est\b/i.test(seg);
  if (isZest){
    return { key: 'zest_tag', html: zestTagSvg(pfill) };
  }

  // Priority 2: Atomic (behaves like tag/disc)
  if (/\batomic\b/i.test(seg)){
    return { key: 'atomic', html: atomicTagSvg(pfill) };
  }

  // Priority 3: Disc / Tag (plural-safe already)
  if (/\b(?:disc|discs|tag|tags)\b/i.test(seg)){
    return { key: 'disc_tag', html: discTagSvg(pfill) };
  }

  // Heart modes (ordered)
  const hasHeart = /\bheart\b/.test(s);
  if (hasHeart){

    // Heart bead (plural-safe)
    if (/\bheart\s*beads?\b/.test(s)){
      return { key: 'heart_bead', html: beadSvg('heart', pfill) };
    }

    // Heart cutout/inlay/insert/hoop (plural + hyphen-safe)
    // Accepts:
    // - cutout / cutouts
    // - cut out / cut outs
    // - cut-out / cut-outs
    // - hoop / hoops
    // - insert / inserts
    // - inlay / inlays
    if (
      /\bcut(?:\s|-)?outs?\b/.test(s) ||
      /\bhoops?\b/.test(s) ||
      /\binserts?\b/.test(s) ||
      /\binlays?\b/.test(s)
    ){
      return { key: 'heart_inlay', html: heartInlaySvg(pfill) };
    }

    // Heart gem (plural-safe)
    if (RX_GEM_WORD.test(s)){
      return { key: 'heart_gem', html: heartGemSvg(getGem1Fill()) };
    }

    // Default heart feature (no hole)
    return { key: 'heart', html: beadSvg('heart_charm', pfill) };
  }

  // Donut beads feature (already plural-safe via beads?)
  if (/\bdonut\b/.test(s) && RX_BEAD_WORD.test(s)){
    return { key: 'donut', html: beadSvg('donut', pfill) };
  }

  // Pearl feature (plural not really needed, but safe)
  if (/\bpearl(s)?\b/.test(s)){
    let pearlFill = '#efe6d2';
    try {
      if (typeof zestBeadFill === 'function') pearlFill = zestBeadFill('pearl');
    } catch(e){}
    return { key: 'pearl', html: beadSvg('normal', pearlFill) };
  }

  // Marquise gem (plural-safe on gem word not required, but ok if present)
  if (/\bmarquise\b/.test(s)){
    return { key: 'marquise_gem', html: marquiseGemSvg(getGem1Fill()) };
  }

  // Square gem / square cut stone (plural + variant-safe)
  // Matches:
  // - "Square Gem", "Square Stone", "Square Jewel(s)"
  // - "Square Cut Stone(s)" / "Square Faceted Stone(s)" / "Square Shaped Stone(s)" / "Square Bumpy Stone(s)"
  if (
    /\bsquare\b/.test(s) &&
    /\b(?:cut|faceted|shaped|bumpy)?\b/.test(s) && // harmless; keeps intent aligned
    /\bsquare\b(?:\s+(?:cut|faceted|shaped|bumpy))?\s+/.test(s) &&
    RX_GEM_WORD.test(s)
  ){
    return { key: 'square_gem', html: squareGemSvg(getGem1Fill()) };
  }

  // ✅ Pear gem (ORDER-SENSITIVE) — plural-safe
  // Only triggers when shape-word appears BEFORE gem/jewel/stone(s).
  if (/\b(?:pear|tear|teardrop)\b.*\b(?:gem|gems|jewel|jewels|stone|stones)\b/.test(s)){
    return { key: 'pear_gem', html: pearGemSvg(getGem1Fill()) };
  }

  // ✅ Teardrop Pendant (plural-safe already)
  if (/\b(?:pear|tear|teardrop|bean|drop|droplet|droplets)\b.*\bpendants?\b/.test(s)){
    return { key: 'teardrop_pendant', html: teardropPendantSvg(pfill) };
  }

// ============================================================
// STAR / SUN REMAP
// ============================================================

// ⭐ NEW: 5-point star (clean feature icon)
if (/\bstars?\b/.test(s)){
  return { key: 'star_5pt', html: fivePointStarSvg(pfill) };
}

// ✴️ EXISTING star icon now used for starburst / sun
if (/\b(starburst|sun|burst)\b/.test(s)){
  return { key: 'starburst', html: beadSvg('star', pfill) };
}

  // Generic bead-word fallback (single icon per segment) — plural-safe already
  if (RX_BEAD_WORD.test(s)){
    if (/\btwist\b/.test(s)) return { key:'twist', html: beadSvg('twist', pfill) };
    if (/\bdrop\b/.test(s))  return { key:'drop',  html: beadSvg('drop',  pfill) };
    if (/\bball\b/.test(s))  return { key:'ball',  html: beadSvg('ball',  pfill) };
    return { key:'beads', html: beadSvg('normal', pfill) };
  }

  return null;
}
/* --- END REPLACEMENT: winnerForSegment() --- */

/* ============================================================
ROLLBACK BLOCK (manual):
- Replace winnerForSegment() with the previous version you pasted above
============================================================ */


  // ---------- build icons: one per segment + de-dupe by winner key ----------
  const segments = splitSegments(fRaw);
  const seen = new Set();
  const chunks = [];

  segments.forEach(seg => {
    const win = winnerForSegment(seg);
    if (!win || !win.html) return;
    if (seen.has(win.key)) return;
    seen.add(win.key);
    chunks.push(win.html);
  });

  const html = chunks.join('');

  if (!html){
    if (rowIcon){ rowIcon.innerHTML = ''; rowIcon.style.display = 'none'; }
    if (headerIcon){ headerIcon.innerHTML = ''; headerIcon.style.display = 'none'; }
    return;
  }

  if (rowIcon) rowIcon.innerHTML = html;

  if (headerIcon){
    // If multiple icons, wrap as a pack so it behaves as one unit visually
    const svgCount = (html.match(/<svg\b/g) || []).length;
    headerIcon.innerHTML = (svgCount > 1)
      ? `<span class="zest-summary-pack" style="display:inline-flex;align-items:center;gap:var(--zest-header-icon-gap);line-height:0;">${html}</span>`
      : html;
  }
}
/* --- END REPLACEMENT: setFeatureIcon() --- */



/* --- BEGIN REPLACEMENT: setBeadIcon() --- */
function setBeadIcon(root, whichField, beadText, platingNameForThisBead){

  const isBead1 = (whichField === 'bead_1_desc');

  const row = root.querySelector('.spec-item[data-field="'+whichField+'"]');
  const rowIcon = row?.querySelector('.spec-icon.zest-i--'+(isBead1?'bead1':'bead2'))
              || row?.querySelector('.spec-icon.zest-i--bead')
              || row?.querySelector('.spec-icon');

  let headerIcon =
    root.querySelector('.zest-summary-icons .zest-i--'+(isBead1?'bead1':'bead2')) ||
    root.querySelector('.zest-summary-icons [data-icon="'+(isBead1?'bead1':'bead2')+'"]');

  const bRaw = (beadText || '').toString().trim();
  const has = bRaw.length > 0;

  if (rowIcon) rowIcon.style.display = has ? '' : 'none';
  if (headerIcon) headerIcon.style.display = has ? '' : 'none';

  if (!has){
    if (rowIcon) rowIcon.innerHTML = '';
    if (headerIcon){
      headerIcon.innerHTML = '';
      headerIcon.style.display = 'none';
      if (headerIcon.parentNode) headerIcon.parentNode.removeChild(headerIcon);
    }
    return;
  }

  const parts = zestGetParts(bRaw).slice(0,4);

  // Detail row: unchanged (already supports donut via zestBeadType + beadSvg)
  const detailHtml = zestIconsHtmlFromParts(parts, platingNameForThisBead);
  if (rowIcon) rowIcon.innerHTML = detailHtml;

  // ✅ NEW (donut-only): if ANY part resolves to donut, show donut in summary slot
  // This avoids the existing “normal-only” filter removing the bead summary entirely.
  const hasDonut = parts.some(p => zestBeadType(zestNormalizeBeadPart(p)) === 'donut');
  if (hasDonut){
    const pfill = platingColors(platingNameForThisBead || '').fill;
    if (headerIcon){
      headerIcon.style.display = '';
      headerIcon.innerHTML = beadSvg('donut', pfill);
    }
    return;
  }

  // Existing summary logic (normal-only segmented) — unchanged
  const summaryParts = parts
    .map(partRaw => zestNormalizeBeadPart(partRaw))
    .filter(part => zestBeadType(part) === 'normal')
    .slice(0,4);

  if (!summaryParts.length){
    if (headerIcon){
      headerIcon.innerHTML = '';
      headerIcon.style.display = 'none';
      if (headerIcon.parentNode) headerIcon.parentNode.removeChild(headerIcon);
    }
    return;
  }

  if (summaryParts.length === 1){
    const fill = zestBeadFill(summaryParts[0]);
    if (headerIcon){
      headerIcon.style.display = '';
      headerIcon.innerHTML = beadSvg('normal', fill);
    }
    return;
  }

  const fills = summaryParts.map(part => zestBeadFill(part)).slice(0,4);

  if (headerIcon){
    headerIcon.style.display = '';
    headerIcon.innerHTML = zestSegmentedBeadSvg(fills);
  }
}
/* --- END REPLACEMENT: setBeadIcon() --- */


/* ============================================================
ROLLBACK BLOCK (manual):
- Replace zestBeadType(), beadSvg(), setBeadIcon() with your previous versions
============================================================ */


 function setRopeIcon(root, ropeText){
  const ropeRow = root.querySelector('.spec-item[data-field="rope"]');

  let rowIcon =
    ropeRow?.querySelector('.spec-icon.zest-i--rope') ||
    ropeRow?.querySelector('.spec-icon');

  // ✅ Defensive: create placeholder if missing
  if (ropeRow && !rowIcon){
    const valueEl = ropeRow.querySelector('.spec-value');
    rowIcon = document.createElement('span');
    rowIcon.className = 'spec-icon zest-i--rope';
    rowIcon.setAttribute('aria-hidden', 'true');

    if (valueEl && valueEl.parentNode){
      valueEl.parentNode.insertBefore(rowIcon, valueEl.nextSibling);
    } else {
      ropeRow.appendChild(rowIcon);
    }
  }

  const headerIcon =
    root.querySelector('.zest-summary-icons .zest-i--rope') ||
    root.querySelector('.zest-summary-icons [data-icon="rope"]');

  const txt = (ropeText || '').toString().trim();
  const has = txt.length > 0;

  if (rowIcon) rowIcon.style.display = has ? '' : 'none';
  if (headerIcon) headerIcon.style.display = has ? '' : 'none';

  if (!has){
    if (rowIcon) rowIcon.innerHTML = '';
    if (headerIcon) headerIcon.innerHTML = '';
    return;
  }

  const svg = ropeSvg( ropeColor(txt) );

  // ✅ Force overwrite so “old style” rope SVG can’t linger
  if (rowIcon) rowIcon.innerHTML = svg;
  if (headerIcon) headerIcon.innerHTML = svg;
}

  function setGemVisibility(root, g1, g2){
    const has1 = (g1 || '').toString().trim().length > 0;
    const has2 = (g2 || '').toString().trim().length > 0;

    const h1 = root.querySelector('.zest-summary-icons .zest-i--gem1') || root.querySelector('.zest-summary-icons [data-icon="gem1"]');
    const h2 = root.querySelector('.zest-summary-icons .zest-i--gem2') || root.querySelector('.zest-summary-icons [data-icon="gem2"]');
    if (h1) h1.style.display = has1 ? '' : 'none';
    if (h2) h2.style.display = has2 ? '' : 'none';
  }

  function setPlatingVisibility(root, platingText){
    const has = (platingText || '').toString().trim().length > 0;
    const h = root.querySelector('.zest-summary-icons .zest-i--plating')
          || root.querySelector('.zest-summary-icons [data-icon="plating"]');
    if (h) h.style.display = has ? '' : 'none';
  }

  function setSummaryPlatingIcon(root, platingText){
  const h = root.querySelector('.zest-summary-icons .zest-i--plating')
        || root.querySelector('.zest-summary-icons [data-icon="plating"]');

  if (!h) return;

  const parts = parsePlatingsUpTo3(platingText);
  if (parts.length === 0) return;

  if (parts.length === 3){
    h.innerHTML = platingSvgThirds(
      platingColors(parts[0]),
      platingColors(parts[1]),
      platingColors(parts[2])
    );
    return;
  }

  if (parts.length === 2){
    h.innerHTML = platingSvgSplit(platingColors(parts[0]), platingColors(parts[1]));
    return;
  }

  h.innerHTML = platingSvgSingle(platingColors(parts[0]));
}

/* ============================================================
   SUMMARY PRIORITY ENGINE (CANONICAL v1.0)
   ------------------------------------------------------------
   Rules:
   - 925 always shown
   - Feature shown BEFORE plating
   - Feature NEVER suppressed
   - Max 6 visible icons
   - Lower priority icons dropped first
   - Safe if slots removed from DOM
   ============================================================ */

function applySummaryPriorityEngine(root, ctx){

  const summary = root?.querySelector('.zest-summary-icons');
  if (!summary) return;

  const slots = {
    "925":     summary.querySelector('[data-icon="925"]'),
    "feature": summary.querySelector('[data-icon="feature"], .zest-i--feature'),
    "plating": summary.querySelector('[data-icon="plating"], .zest-i--plating'),
    "bead1":   summary.querySelector('[data-icon="bead1"], .zest-i--bead1'),
    "bead2":   summary.querySelector('[data-icon="bead2"], .zest-i--bead2'),
    "gem1":    summary.querySelector('[data-icon="gem1"], .zest-i--gem1'),
    "gem2":    summary.querySelector('[data-icon="gem2"], .zest-i--gem2'),
    "rope":    summary.querySelector('[data-icon="rope"], .zest-i--rope')
  };

  // Hide all except 925 (we re-enable selectively)
  Object.keys(slots).forEach(k => {
    const el = slots[k];
    if (!el) return;
    if (k === "925") return;
    el.style.display = 'none';
  });

  // 925 always visible
  if (slots["925"]) slots["925"].style.display = '';

  const featureEl = slots["feature"];
  const featureHas =
    !!(featureEl && featureEl.innerHTML && featureEl.innerHTML.trim().length > 0);

  const priority = ["925"];

  if (featureHas) priority.push("feature");
  if ((ctx.platingText || '').trim()) priority.push("plating");
  if ((ctx.bead1 || '').trim()) priority.push("bead1");
  if ((ctx.bead2 || '').trim()) priority.push("bead2");
  if ((ctx.gem1 || '').trim()) priority.push("gem1");
  if ((ctx.gem2 || '').trim()) priority.push("gem2");
  if ((ctx.ropeText || '').trim()) priority.push("rope");

  const mustKeep = new Set(["925"]);
  if (featureHas) mustKeep.add("feature");

  let shown = 0;

  // Pass 1 — mustKeep
  for (const key of priority){
    if (!mustKeep.has(key)) continue;
    const el = slots[key];
    if (!el) continue;
    el.style.display = '';
    shown++;
  }

  // Pass 2 — fill remaining up to 6
  for (const key of priority){
    if (mustKeep.has(key)) continue;
    if (shown >= 6) break;

    const el = slots[key];
    if (!el) continue;

    const canShow =
      key === "plating" ||
      key === "rope" ||
      key === "gem1" ||
      key === "gem2" ||
      (el.innerHTML && el.innerHTML.trim().length > 0);

    if (!canShow) continue;

    el.style.display = '';
    shown++;
  }
}

/**
 * Backwards-compatible wrapper (keeps existing call sites untouched)
 */
function enforceHeaderMax6(root, platingText, featureText, bead1, bead2, gem1, gem2, ropeText){
  return applySummaryPriorityEngine(root, {
    platingText,
    featureText,
    bead1,
    bead2,
    gem1,
    gem2,
    ropeText
  });
}

  function update(id){
    if(!id) return;

    const map = getMap();
    const data = map[String(id)] || {};
    const root = document.getElementById('variant-specs');
    if(!root) return;

    const productMeta = getProductMeta();
    const productFeature = decodeEntities(productMeta.feature || productMeta.feature_desc || '').trim();

    const variant_name = decodeEntities(data.variant_name || '');
    const colour = decodeEntities(data.colour || '');
    const feature = decodeEntities(data.feature || data.feature_desc || '').trim() || productFeature;

    const platingText = decodeEntities(data.variant_plating || '');
    const gem1 = decodeEntities(data.gemstone_1_desc || '');
    const gem2 = decodeEntities(data.gemstone_2_desc || '');
    const bead1 = decodeEntities(data.bead_1_desc || '');
    const bead2 = decodeEntities(data.bead_2_desc || '');
    const rope = decodeEntities(data.rope || '');
    const weight = decodeEntities(data.weight || '');

    setRow(root, 'variant_name', 'Option:', variant_name);
    setRow(root, 'colour', 'Colour:', colour);
    setRow(root, 'feature', 'Feature:', feature);

    setRow(root, 'variant_plating', 'Plating:', platingText);
    setPlatingRowIcons(root, platingText);

    setRow(root, 'gemstone_1_desc', 'Gem:', gem1);
    setRow(root, 'gemstone_2_desc', '2nd Gem:', gem2);
    setRow(root, 'bead_1_desc', 'Bead:', bead1);
    setRow(root, 'bead_2_desc', '2nd Bead:', bead2);
    setRow(root, 'rope', 'Rope:', rope);
    setRow(root, 'weight', 'Weight:', weight);

    (function(){
      const row = root.querySelector('.spec-item[data-field="variant_description"]');
      if (!row) return;
      const val = decodeEntities(data.variant_description || '').trim();
      row.style.display = val ? '' : 'none';
      const valueEl = row.querySelector('.spec-value');
      if (valueEl) valueEl.textContent = val;
    })();

    (function(){
      const raw = decodeEntities(data.size_description || '').trim();
      const row = root.querySelector('.spec-item[data-field="size_description"]');
      if (!row) return;

      if (!raw){ row.style.display = 'none'; return; }
      row.style.display = '';

      const labelEl = row.querySelector('.spec-label');
      const valueEl = row.querySelector('.spec-value');

      const lower = raw.toLowerCase();
      if (lower.startsWith('height:')){
        if (labelEl) labelEl.textContent = 'Height:';
        if (valueEl) valueEl.textContent = raw.split(':').slice(1).join(':').trim();
      } else if (lower.startsWith('length:')){
        if (labelEl) labelEl.textContent = 'Length:';
        if (valueEl) valueEl.textContent = raw.split(':').slice(1).join(':').trim();
      } else {
        if (labelEl) labelEl.textContent = 'Size:';
        if (valueEl) valueEl.textContent = raw;
      }
    })();

    (function(){
      const skuRow = root.querySelector('.zest-sku');
      if (!skuRow) return;
      const skuVal = decodeEntities(data.sku || '').trim();
      skuRow.style.display = skuVal ? '' : 'none';
      const el = skuRow.querySelector('.zest-sku__value');
      if (el) el.textContent = skuVal;
    })();

    const platings = parsePlatings(platingText);
    const plating1 = platings[0] || '';
    const plating2 = platings[1] || '';
    const hasTwoPlatings = (platings.length === 2);

    const bead1IsSpecial = beadType(bead1) !== 'normal' && bead1.trim().length > 0;
    const bead2IsSpecial = beadType(bead2) !== 'normal' && bead2.trim().length > 0;
    const featureIsSpecialBead = (feature || '').toLowerCase().includes('bead');

    const platingForBead1 = plating1;
    const platingForBead2 = (hasTwoPlatings && bead2IsSpecial) ? plating2 : plating1;

    let platingForFeature = plating1;
    if (hasTwoPlatings && featureIsSpecialBead && bead1IsSpecial) {
      platingForFeature = plating2;
    }

    applyVars(root, plating1, gem1, gem2, bead1, bead2, rope);

    setPlatingVisibility(root, platingText);
    setSummaryPlatingIcon(root, platingText);

    setGemVisibility(root, gem1, gem2);

    setFeatureIcon(root, feature, platingForFeature);
    setBeadIcon(root, 'bead_1_desc', bead1, platingForBead1);
    setBeadIcon(root, 'bead_2_desc', bead2, platingForBead2);
    setRopeIcon(root, rope);

 // ------------------------------------------------------------
// SUMMARY DE-DUPE (Feature priority)
// Rule:
// - If Feature contains "pearl"
// - AND bead1 or bead2 contains pearl
// => Hide bead summary icon(s), keep Feature icon.
// ------------------------------------------------------------
(function(){
  const f = (feature || '').toLowerCase();
  if (!f.includes('pearl')) return;

  const bead1HasPearl = (bead1 || '').toLowerCase().includes('pearl');
  const bead2HasPearl = (bead2 || '').toLowerCase().includes('pearl');

  if (!bead1HasPearl && !bead2HasPearl) return;

  const bead1HeaderIcon =
    root.querySelector('.zest-summary-icons .zest-i--bead1') ||
    root.querySelector('.zest-summary-icons [data-icon="bead1"]');

  const bead2HeaderIcon =
    root.querySelector('.zest-summary-icons .zest-i--bead2') ||
    root.querySelector('.zest-summary-icons [data-icon="bead2"]');

if (bead1HasPearl && bead1HeaderIcon && bead1HeaderIcon.parentNode){
  bead1HeaderIcon.parentNode.removeChild(bead1HeaderIcon);
}


if (bead2HasPearl && bead2HeaderIcon && bead2HeaderIcon.parentNode){
  bead2HeaderIcon.parentNode.removeChild(bead2HeaderIcon);
}

})();


    enforceHeaderMax6(root, platingText, feature, bead1, bead2, gem1, gem2, rope);

/* ============================================================
PATCH ID: ZEST-PD-PATCH-20260220-SUPPRESS-BOHO-SUMMARY-v1
TYPE: Bug fix
PURPOSE:
- Treat "boho" bead descriptions as donut-style special beads for SUMMARY suppression
- Ensures Boho does NOT appear in summary row (same rule as donut)
SCOPE:
- Full replacement of the existing ZEST-PD-SUMMARY-SUPPRESS-SPECIAL-BEADS-v1 block
ROLLBACK:
- Restore previous suppression block
============================================================ */
(function(){
  function suppressIfSpecial(which){
    const txt = (which === 1) ? (bead1 || '') : (bead2 || '');
    const raw = (txt || '').toString().trim();
    if (!raw) return;

    const n = raw.toLowerCase();

    // ✅ NEW: boho should behave like donut for summary suppression
    const isBoho = /\bboho\b/.test(n);

    // canonical classifier: heart/twist/donut/drop/ball/star/normal
    const t = beadType(raw);
    const isSpecial = isBoho || (t && t !== 'normal');

    const sel = (which === 1)
      ? ('.zest-summary-icons .zest-i--bead1, .zest-summary-icons [data-icon="bead1"]')
      : ('.zest-summary-icons .zest-i--bead2, .zest-summary-icons [data-icon="bead2"]');

    const el = root.querySelector(sel);
    if (!el) return;

    if (isSpecial){
      // Force-hide and clear so priority engine cannot "canShow" it later
      el.style.display = 'none';
      el.innerHTML = '';
      el.setAttribute('data-zest-suppressed', 'specialbead');
      return;
    }

    // If previously suppressed, release (visibility still governed by priority engine)
    if (el.getAttribute('data-zest-suppressed') === 'specialbead'){
      el.removeAttribute('data-zest-suppressed');
    }
  }

  suppressIfSpecial(1);
  suppressIfSpecial(2);
})();

/* ============================================================
PATCH ID: ZEST-PD-SUPPRESS-ALL-SPECIAL-GEMS-v3
TYPE: Bug fix
PURPOSE:
- Suppress Gem1 when Feature is a SPECIAL GEM icon:
    • Heart + (gem|jewel|stone)
    • Marquise (gem implied)
    • Pear/Tear/Teardrop ONLY when used as a GEM (requires gem|jewel|stone)
    • Square ONLY when used as a GEM (requires gem|jewel|stone)
- IMPORTANT: Do NOT suppress for Pendant features
ROLLBACK:
- Restore v2 block
============================================================ */
(function(){

  const f = (feature || '').toLowerCase();
  const gem1Has = (gem1 || '').toString().trim().length > 0;
  if (!gem1Has) return;

  // If it's a pendant feature, we never suppress Gem1
  const isPendantFeature = /\bpendants?\b/.test(f);

  // Special gem feature detection (ONLY)
  const isHeartGem =
    /\bheart\b/.test(f) &&
    /\b(gems?|jewels?|stones?)\b/.test(f);

  const isMarquiseGem =
    /\bmarquise\b/.test(f) &&
    !isPendantFeature; // safety

  // Pear/Tear/Teardrop counts as a special gem ONLY when explicitly a gem/jewel/stone
  const isPearGem =
    /\b(pear|tear|teardrop)\b/.test(f) &&
    /\b(gems?|jewels?|stones?)\b/.test(f) &&
    !isPendantFeature;

  // ✅ Square counts as a special gem ONLY when explicitly a gem/jewel/stone
  // Matches: "square cut stone", "square gem", "square bumpy stone"
  const isSquareGem =
    /\bsquare\b.*\b(gems?|jewels?|stones?)\b/.test(f) &&
    !isPendantFeature;

  const shouldSuppress = !isPendantFeature && (isHeartGem || isMarquiseGem || isPearGem || isSquareGem);

  const gem1HeaderIcon =
    root.querySelector('.zest-summary-icons .zest-i--gem1') ||
    root.querySelector('.zest-summary-icons [data-icon="gem1"]');

  if (!gem1HeaderIcon) return;

  if (shouldSuppress){
    gem1HeaderIcon.style.display = 'none';
    gem1HeaderIcon.setAttribute('data-zest-suppressed', 'specialgem');
    return;
  }

  // Clear previous suppression if no longer needed
  if (gem1HeaderIcon.getAttribute('data-zest-suppressed') === 'specialgem'){
    gem1HeaderIcon.removeAttribute('data-zest-suppressed');
    gem1HeaderIcon.style.display = '';
  }

})();




    if (typeof lockCheck === 'function') lockCheck(root, platingText, bead1, bead2, rope);

    devLog('sync', { id, platingText, bead1, bead2, feature, rope });
  }

  let last = null;

 function sync(force){
  const id = getVariantIdFromForm() || getVariantIdFromURL();
  if (!id) return;

  // Theme editor can re-render DOM and wipe injected SVGs without changing variant id.
  // Detect "wiped injection" and force a repaint for the current variant.
  let needsRepaint = false;
  try {
    const root = document.getElementById('variant-specs');
    if (root){
      const summary = root.querySelector('.zest-summary-icons');
      if (summary){
        const bead1El = summary.querySelector('[data-icon="bead1"], .zest-i--bead1');
        const bead2El = summary.querySelector('[data-icon="bead2"], .zest-i--bead2');
        const platingEl = summary.querySelector('[data-icon="plating"], .zest-i--plating');
        const ropeEl = summary.querySelector('[data-icon="rope"], .zest-i--rope');

        const bead1RowVal = root.querySelector('.spec-item[data-field="bead_1_desc"] .spec-value')?.textContent?.trim() || '';
        const bead2RowVal = root.querySelector('.spec-item[data-field="bead_2_desc"] .spec-value')?.textContent?.trim() || '';

        // If a bead value exists but its summary slot is empty, we need to re-inject.
        if (bead1RowVal && bead1El && !bead1El.innerHTML.trim()) needsRepaint = true;
        if (bead2RowVal && bead2El && !bead2El.innerHTML.trim()) needsRepaint = true;

        // Also catch cases where the whole row got wiped
        if (platingEl && !platingEl.innerHTML.trim()) needsRepaint = true;
        if (ropeEl && !ropeEl.innerHTML.trim()) needsRepaint = true;
      } else {
        // Summary container missing entirely (re-render) → repaint
        needsRepaint = true;
      }
    }
  } catch(e){}

  if (force || id !== last || needsRepaint){
    last = id;
    update(id);
  }
}

  window.__zestPD.sync = sync;

  document.addEventListener('DOMContentLoaded', ()=>sync(true));
  window.addEventListener('load', ()=>setTimeout(()=>sync(true), 0));

  document.addEventListener('change', ()=>setTimeout(sync,0), true);
  document.addEventListener('click',  ()=>setTimeout(sync,0), true);

  window.addEventListener('popstate', ()=>setTimeout(sync,0));
  (function(){
    const _push = history.pushState;
    const _replace = history.replaceState;
    history.pushState = function(){
      _push.apply(this, arguments);
      setTimeout(sync, 0);
    };
    history.replaceState = function(){
      _replace.apply(this, arguments);
      setTimeout(sync, 0);
    };
  })();

  const obs = new MutationObserver(()=>setTimeout(sync,0));
  obs.observe(document.documentElement, {subtree:true, childList:true});

  sync(true);

})();
